/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
export const useAutoIDStore = defineStore("autoIDStore", {
  state: () => ({
    autoIdOptions: {}
  }),
  actions: {
    async assignOptions(me) {
      this.autoIdOptions["custom"] = {
        pattern: "custom",
        label: "Manually Generated",
        description: `LeanLaw will not automate any Client or ${me.terms.Matter} IDs. These fields will be left blank unless modified by the user.`,
        nextNumberRequired: false,
        usingClientOnlyID: false,
        usingClientAndMatterID: false,
        usingMatterOnlyID: false,
        preview: function (nextNumber) {
          var preview = [{
            client: "xxxx",
            matter: "xxxx"
          }, {
            client: "xxxx",
            matter: "xxxx"
          }, {
            client: "xxxx",
            matter: "xxxx"
          }];
          return preview;
        }
      };
      this.autoIdOptions["numbers"] = {
        pattern: "numbers",
        label: "Numerical",
        description: `LeanLaw will generate a Client ID using the Starting/Next Client Number, increasing by 1 for each client created. Each client\'s ${me.terms.Matter} ID will begin at 1 and increase by 1 for each matter created under the client.`,
        nextNumberRequired: true,
        usingClientOnlyID: false,
        usingClientAndMatterID: true,
        usingMatterOnlyID: false,
        preview: function (nextNumber) {
          function example(clientNum, matterNum) {
            return clientNum <= 9999 ? {
              client: ("0000" + clientNum).slice(-4),
              matter: matterNum
            } : {
              client: clientNum,
              matter: matterNum
            };
          }
          var preview = [example(nextNumber, 1), example(nextNumber + 1, 1), example(nextNumber + 1, 2)];
          return preview;
        }
      };
      this.autoIdOptions["year"] = {
        pattern: "year",
        label: "Year + Numerical (Client)",
        description: `LeanLaw will generate a Client ID using the last two digits of the current year followed by a hyphen and the Starting/Next Client Number. The number increases by 1 each client created. ${me.terms.Matter} IDs must be manually entered.`,
        nextNumberRequired: true,
        usingClientOnlyID: true,
        usingClientAndMatterID: false,
        usingMatterOnlyID: false,
        preview: function (nextNumber) {
          function example(clientNum) {
            return clientNum <= 9999 ? {
              client: CURRENT_YEAR + "-" + ("0000" + clientNum).slice(-4),
              matter: ""
            } : {
              client: CURRENT_YEAR + "-" + clientNum,
              matter: ""
            };
          }
          var d = new Date();
          var _currFullYear = d.getFullYear();
          const CURRENT_YEAR = ("00" + _currFullYear.toString()).slice(-2); //Get last two digits of current year

          var preview = [example(nextNumber), example(nextNumber + 1), example(nextNumber + 1)];
          return preview;
        }
      };
      this.autoIdOptions["matterYear"] = {
        pattern: "matterYear",
        label: "Year + Numerical (" + me.terms.Matter + ")",
        description: "LeanLaw will generate a " + me.terms.Matter + " ID using the last two digits of the current year followed by a hyphen and the Starting/Next " + me.terms.Matter + " Number. The number increases by 1 for each " + me.terms.Matter + " created under a client. Client IDs must be manually entered.",
        nextNumberRequired: true,
        usingClientOnlyID: false,
        usingClientAndMatterID: false,
        usingMatterOnlyID: true,
        preview: function (nextNumber) {
          var d = new Date();
          var _currFullYear = d.getFullYear();
          const CURRENT_YEAR = ("00" + _currFullYear.toString()).slice(-2); //Get last two digits of current year

          function example(matterNum) {
            return matterNum <= 9999 ? {
              client: "",
              matter: CURRENT_YEAR + "-" + ("0000" + matterNum).slice(-4)
            } : {
              client: "",
              matter: CURRENT_YEAR + "-" + matterNum
            };
          }
          var preview = [example(nextNumber), example(nextNumber + 1), example(nextNumber + 2)];
          return preview;
        }
      };
      this.autoIdOptions["matterNumbers"] = {
        pattern: "matterNumbers",
        label: me.terms.Matter + "-only ID",
        description: "LeanLaw will generate " + me.terms.Matter + " IDs using the Starting/Next Matter Number, increasing by 1 for each new " + me.terms.matter + " created under a client. Client IDs must be manually entered.",
        nextNumberRequired: true,
        usingClientOnlyID: false,
        usingClientAndMatterID: false,
        usingMatterOnlyID: true,
        preview: function (nextNumber) {
          function example(matterNum) {
            return matterNum <= 9999 ? {
              client: "",
              matter: ("0000" + matterNum).slice(-4)
            } : {
              client: "",
              matter: matterNum
            };
          }
          var preview = [example(nextNumber), example(nextNumber + 1), example(nextNumber + 2)];
          return preview;
        }
      };
      return this.autoIdOptions;
    }
  }
});